export default __webpack_public_path__ + "static/media/ua-safety-screenshot.5a0a44a1.png";